/* global Sys, Utils */
Sys.ns("Utils");

Utils.CONSTANTS = {
    JURISDICTION_SPECIFIC_CODES: {
        SHOW_GAME_INFORMATION: ["CH"]
    },

    REASON_CODES: {

        /*
            gameId: The game ID of the game that triggered the "bounce-back".
            sessionId: The game session ID (starting with DEMO if it is a "Play for Fun" session).
            reason: A code defining the reason for going back to the lobby.

            "0" = A normal game termination (the player selected to go to the lobby using the lobby button in the game).
            "1" = The game was started from a bookmark; a login (real or for fun) is required to obtain a web session and play the game.
            "3" = Session time-out.
            "4" = Play for real promotion has been displayed in-game, and the player wants to register and play for real money.
            "5" = The player ran out of money when playing a game, and wants to deposit more money.
            "6" = The device is confirmed but not supported.
            "9" = An error occurred in the game and the player chose to go to the lobby.
            "11" = When player acknowledges Player Limit and terminates.
            "12" = The game redirect to lobby, if the game is refreshed without iframe using a desktop user agent.
        */
        NORMAL_GAME_TERMINATION: "0",
        BOOKMARK: "1",
        SESSION_TIMEOUT: "3",
        WANTS_TO_PLAY_FOR_REAL: "4",
        WANTS_TO_DEPOSIT_MONEY: "5",
        DEVICE_NOT_SUPPORTED: "6",
        TECHNICAL_ERROR: "9",
        ACKNOWLEDGES_PLAYER_LIMIT: "11",
        NON_COMPLIANT: "12"
    }
};
